import { TranslateService } from 'Public_old/src/app/Common/Services/translate.service';
import {
	Component,
	ElementRef,
	EnvironmentInjector,
	EventEmitter,
	forwardRef,
	Injector,
	Input,
	inject,
	Output,
	Self,
	ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, UntypedFormControl } from '@angular/forms';
import { GlobalValidator } from '../Classes/globalValidator';
import { NationalIdentityNumbers } from '../Classes/nationalIdentityNumbers';

const countries = [
	{
		CountryCode: 'SE',
		DescriptiveName: 'Sweden',
		placeholder: 'YYYYMMDD-XXXX',
		Image:
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVCAYAAAA0GqweAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA5NUZDMUFEMzZGNjExRTZCQzBDQ0RBRkVCQ0FCMTg1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjA5NUZDMUFFMzZGNjExRTZCQzBDQ0RBRkVCQ0FCMTg1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDk1RkMxQUIzNkY2MTFFNkJDMENDREFGRUJDQUIxODUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDk1RkMxQUMzNkY2MTFFNkJDMENDREFGRUJDQUIxODUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4GFHJqAAABoUlEQVR42uxXsUoDQRB9e7d3p5doPIMpFKzUHxBsbVSwsRUbC0vJH9ha2foJIlY2tpLGwg+IhYVEJIKV3pGExCRnss4mORRJ7oxx4YoMzA47O8s+Zvbt3DEcXjwAWCKtoJ80krBsD8XdLDJOmebkmwQ2Lo+Qu98CUi9QJFOkBU5D+psjbpLWaBCIrwgNMZcxwFGFQ7CIW8DQNybwR+0fGWBpPpwkdSK3P9G9rgEWaatEfndRITQ6hLXBT7ePeVhYo2XA5g0kzRrQ7HG+DmTXzrG+fAPHrCqBpxO495YJJgooh76BMlttwlXq2mDOUmQt0pY6dtSapseFN1zWg82iMrD3/E+B5RlUMc5mfgFKZrD8I4PTZM2eT1EGmQR4lV8NPcJvc1h6E5sLd7CMjy4gA7h9XMFTZQ5Jo66GvVoLVd+ifOxfv9F8NozFVsJF8WAPmXSpQxDY9LFwdoJcfgdwnhXWWXgcdsQl1H10Ypj46trSWnQBE6+I3D/yO6hF0FCu94vRqNb6gLVxLx4DHA4gizE+JvuwS+qo7Qt//idxPwUYAG4Ed2yfCLYoAAAAAElFTkSuQmCC',
	},
	{
		CountryCode: 'FI',
		DescriptiveName: 'Finland',
		placeholder: 'DDMMYY-XXXX',
		Image:
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVCAYAAAA0GqweAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjAzMzU5MEM4MzZGNjExRTY5M0RCQkVDQTZDRUFGMjhGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjAzMzU5MEM5MzZGNjExRTY5M0RCQkVDQTZDRUFGMjhGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDMzNTkwQzYzNkY2MTFFNjkzREJCRUNBNkNFQUYyOEYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDMzNTkwQzczNkY2MTFFNjkzREJCRUNBNkNFQUYyOEYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4se0c4AAABVElEQVR42uyXzUrDQBSFT5pJfxJS0YhIpdBFFz6ACK4FXRSfwRfwAVy7dOtDiOAbKOLWhWsRKYIoIsWkpDamaX48IV24MehiaMAcuBNmuJDv3pncO1GSJHkA0KWN8IMmQYh27xCD/gvQNADbxeX5EbY31yFRJq0vOFjfFoomq8IhQXGVVFBwlYD/ArDIHwnEwfGpyHOoVQW8zwAfng/odYbEmEwdJ2dXuL69hzPypIBFUYxGTYOChZ6bWwPpCKECnVWAsIiZcJWQT2/AcJytydA0hN40HIHu2h/CirNnGAGt5cxkacp3mA0IPL7mO8aEUpnB9sosg7P58wBwmUFNXgbTtir29nfjPD+N25v24oubOwRjnkONcL6PrZ0NdFoWz+ZECl/I3TLqVSi8LLxzvpTnPKfLQiqnLNQlYAn4C0ClwHxKWmVt2mLeP8mclLZf+0uAAQABbGryAYpbzwAAAABJRU5ErkJggg==',
	},
	{
		CountryCode: 'NO',
		DescriptiveName: 'Norway',
		placeholder: 'DDMMYYXXXYY',
		Image:
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVCAYAAAA0GqweAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA1RUY5QUZDMzZGNjExRTZBQkIzRjE4MkUzM0IzOTVEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjA1RUY5QUZEMzZGNjExRTZBQkIzRjE4MkUzM0IzOTVEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDVFRjlBRkEzNkY2MTFFNkFCQjNGMTgyRTMzQjM5NUQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDVFRjlBRkIzNkY2MTFFNkFCQjNGMTgyRTMzQjM5NUQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz67Pxy1AAABwklEQVR42mI57mZ7hoGBwRiIPzMggZ8vnjNIObsyqPZNY4jP72BYtnwLg7+3A8Oa+S0MjzsbGe4smMfAKSfPQEPAC8QXWICEGpLAYAPKTAyDHIw6cNg7kAWUW7GBH0+fMPx6+xrMZmRkRJH78/49w48njxmY2Nho70BQUYIN/H73lkHE1AzM/v/3L0Tw/38wJaRvwCDnF8DAJi5BeweCyjlC4N/vXxD3/fsHpvkjE8CYHoAxLq/9E9YyEBitjMAQ+//7J8O9B88YPnz4wsDPx82gqCDFwMLOzvCPkQkeojQEnxkZ+M0+4SykQSEGdIO2jiqDuJgQw+u3HxguX74FFAcKMtMlf31mTC3qxh2CINf9+cNw4/ZDhjfvPjAICfAxaKjKMzADM8c/oCw9QhBox/9P/wmAmPT6/yyi1v+DYiv+0xl8Yrldno87F5uYMoil5zMwsUKKE0YmSLR+XL2Y4cm2rQxsYuK0z8VPt23GUQ4+Zvj34zvYgYzMzPBoB4G3Z04zPFy1koFLSZH2DuSQksGevZmYGdhFxaHFH2paYxUSBja15Bhw6R2ti0cdOKxaM0B8G4iN0PskgwCAKo97AAEGAELWG4IXi2Z6AAAAAElFTkSuQmCC',
	},
	{
		CountryCode: 'DK',
		DescriptiveName: 'Denmark',
		placeholder: 'DDMMYY-SSSS',
		Image:
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVCAYAAAA0GqweAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA0ppVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OERGNEMwM0Q0MUVGMTFFN0I5MUJFRDY3MzFCNEU0QzgiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OERGNEMwM0M0MUVGMTFFN0I5MUJFRDY3MzFCNEU0QzgiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpmOGE5ODFjYS00MWVkLTExZTctOWQ3Mi1jOTEwYjQwMDllNzUiIHN0UmVmOmRvY3VtZW50SUQ9ImFkb2JlOmRvY2lkOnBob3Rvc2hvcDpmOGE5ODFjYS00MWVkLTExZTctOWQ3Mi1jOTEwYjQwMDllNzUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7K5fbNAAABT0lEQVR42mI8zMDwiZ+BgfcXAwQwAvF/BkzwA4jVZ85kEElLg4vdtLRkeHviBAM7kjp0/bjMIwRYgfgzEDGBOL+QJMgxjAGPfnLN+w2lmYjVwMgwMICJYZADJnKjbtA5cDSKcQAWUPEBKiZ+Ygmt/2jFzJ9371A0/7x3j+EbVN1/AqH/H4/52PisUDtZpBMSGPhYWRn+EMr2//4x8FhZoYiJFRQwcN+9y8DCxEQweRBTNiKLs4DKwd+/GRj/A8GwyMWjDsSVSW4VFn7mZWPj/YcU0//RihUQ/w8wDYqGhjJwm5vDxV9NmcLw/cEDBmYm6vuTGYi//P79meXhhAkM/Gj1MTbwHYg5hIVRHPi8sZHh1Zs3DJw0CDloY4GBhRPqWk4i0gIL0IHIgENFhYEb6EB2GkUv52gmGXXgUG/N/KeXA9mIcNR/OjfBYG4CCDAAjh1b8TVjSzoAAAAASUVORK5CYII=',
	},
	{
		CountryCode: 'GB',
		DescriptiveName: 'United Kingdom',
		placeholder: 'XXX XXX XXXX',
		Image:
			'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAVCAYAAADB5CeuAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPaSURBVEhL7VZNb1tFFD3zHOeDSimp09pv3nMSt+VjDz8ACVX8hy5ggcoeiU3VJrFTCptKrNkURBE/ACFRhCqxYUUFEqhiUdLIfn7j57amsoB82H6enhm/2FZqNy5h0QXHlvzum/HMmXvvnHuFUkqjD4233/kMt76vJPbhULUrCN1cYvXg1SJIdzWxDseb55Zw/ca7eJDzyaALcRtCt1ICK0E1mUJqXY38UpG/InkzHkchJRyNSnUVkVcwm9p3K/UIzvy1TzAdayjpoXHuLTix4GSBarWEMCzCwYyd/F/CrBmE6/hRfIFILkPQP94PtyBViFYcw3nlgztwVc0OtO/8hmpeIn7xBISgl/gN1EUoVeRSnd6KR0KHnuVh/9qgd3yk4xZ3FXDDAPrlV+0MTcrc+j2bU3NzGlubH9FjLmJ+nCmNU2GNnhuk3MwssJhZ5z8HYZ0ofELjYaOEnVYKkSv7ofJVnRk0OOzZM+vY2RGklcAYrlzFL9e/gwwVuvE0oqxEJe9x0d4ie7tgSEv4/MZ5a08CM7dWvYqtjI8ol4PWmmGq2VDtE7p583f4csNyMOh76iAe/nkVO+1dqGyBzGMbSj+6T7LtZAZPdvoyNrc+HumpM4WLuHuvhJpcsu8cfrJqk8tMW9tgZjaNxROXEmuAsaQM0kihrC7BWTiOytw8LXth7Sn3IURqJKlA5sBLbSPlbm/DedRk1HseN/m67G6gbQ47Agd0ajxMGjm9NS3202ocKbrUPg+l38SwOpU8PzfoJ/rzhP9JTYqJE/0ghE7Ow5I0KtG1Tm4W66i5DBasdUanDsNTJcGIZhgaZU5b0+lS7BYWUD02D4dkOrzvearyU0kRVSmtvMQUlHyzge52C1Je5tUcHaix4Ws0rpHQBp96hGLRhvILlpAR0pwK8Mb0BTs2CmcLLEcJfKU4v0xSKQTHMwhZysKoaPcYhSdIffnVeYQswLt7f1vbiGXo5VF3Vyh2XXgsQbc//RZejrVsb7wImTFPFvH1N79a2xTavKqw+FdIjl1JNo+7mQyicM3uOYyhgizwx+bgdGnmQXk/LNzbqz+gQreQPfXvCnL9fgmdQYVCl3Jfy7kcEozCFJaDLZx+6Qrrn8lBXNABPcOGIZnOdsX3kLLqLeD/0wSaTRbrD2kPSXqCZ2vyHEZhLXk26LKEnUR1bpYjpolJ4STTwglVqU9I//QzAk9aQmLqBRbQe5DH3ichk1tPEnp2MPwMqSfX0GWOGpLdRw34bJH066/ZixCx2bSSINgJhnKx9z8njVwlQIGJ2mkfTuQo7fBU2kG5POw5sFVawmOib7ccySSNzQAAAABJRU5ErkJggg==',
	},
];

@Component({
	standalone: false,
	selector: 'visiba-nin',
	template: `
		<div class="wallInput wallStyling" [class.hasIcon]="icon != null">
			<visiba-svg *ngIf="icon != null" class="iconSvg" [color]="iconColor" [a]="icon"></visiba-svg>
			<label [class.value]="(model.nin != null && model.nin != '') || alwaysShowPlaceholder" [class.svg]="icon != null">{{
				localPlaceholder !== '' ? localPlaceholder : selectedCountry.placeholder
			}}</label>
			<input
				[tabindex]="tabInd"
				[attr.autofocus]="autofocus ? '' : null"
				type="text"
				[maxlength]="selectedCountry.placeholder.length"
				#input
				[readonly]="readonly"
				[(ngModel)]="model.nin"
				(ngModelChange)="validateAndEmitValue()"
				class="main"
			/>
			<input type="text" disabled="disabled" readonly="readonly" [placeholder]="placeholderGenerated" class="placeholder" />
			<div class="countrySelection" *ngIf="countries.length > 1">
				<img [src]="selectedCountry.Image" [alt]="selectedCountry.DescriptiveName" (click)="toggleCountryList()" />
				<visiba-svg (click)="toggleCountryList()" [color]="iconColor" a="ArrowDown"></visiba-svg>
				<visiba-svg *ngIf="model?.nin != null && !readonly" [color]="iconColor" a="X"></visiba-svg>
			</div>
			<div class="select" [class.open]="showList" #ulWrap>
				<ul>
					<ng-template ngFor let-c [ngForOf]="countries">
						<li
							[class.selected]="c.CountryCode === selectedCountry?.CountryCode"
							[class.targeted]="c.CountryCode === targetedCountry?.CountryCode"
							(click)="countryChange(c)"
							(mouseover)="targetedCountry = c"
						>
							<img [src]="c.Image" [alt]="c.DescriptiveName" />
							{{ c.DescriptiveName }}
						</li>
					</ng-template>
				</ul>
			</div>
			<span class="error" [class.value]="model?.nin != null && model?.nin != ''">{{ currentError }}</span>
		</div>
	`,
	host: {
		'[class.readonly]': 'readonly',
	},
})
export class VisibaNationalIdentityNumberComponent implements ControlValueAccessor {
	@Input() tabInd: number = 0;
	@Input() icon: string = null;
	@Input() iconColor: string = null;
	@Input() readonly: boolean;
	@Input() autofocus: boolean = false;
	@Input() availibleCountries: Array<string> = [];
	@Input() errorMessages: { [name: string]: string } | string = 'default';
	@Input('modelValue') model: { nin: string; countryCode: string } = { nin: null, countryCode: µ.LicenceHolder.CountryCode };
	@Input() placeholder: string = null;
	@Input() staticplaceholder: string = null;
	@ViewChild('ulWrap', { static: false }) ulWrap: ElementRef;
	@ViewChild('input', { static: false }) input: ElementRef;

	@Output() onChange = new EventEmitter<{ nin: string; countryCode: string }>();
	@Output() onCountryChange = new EventEmitter<string>();

	placeholderGenerated: string = null;
	localPlaceholder: string = '';
	currentError: string = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	selectedCountry: any = null;
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	targetedCountry: any = null;
	showList: boolean = false;
	alwaysShowPlaceholder = false;
	placeholderSwap = null;

	selectionStart: number = 0;
	selectionEnd: number = 0;

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	countries: any[] = countries;

	constructor(
		private _elem: ElementRef,
		@Self() public controlDir: NgControl,
		private translateService: TranslateService,
	) {
		controlDir.valueAccessor = this;
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	writeValue(value: any) {
		if (!value || typeof value.nin === 'undefined') {
			// Invalid inmodel
			this.model.nin = null;
			return;
		}
		this.model = value;

		// Ignore if unsupported country. Should not show field then anyways
		const country = this.searchCountry(this.model.countryCode);

		if (country && country.CountryCode !== this.model.countryCode) return;

		this.countryChange(country || countries[0]);
		this.validateAndEmitValue();
	}

	//Call to push value
	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	propagateChange = (_: any) => {};

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	registerOnTouch() {}
	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	registerOnTouched() {}

	ngOnInit() {
		if (this.availibleCountries.length > 0)
			this.countries = this.countries.filter((x) => this.availibleCountries.indexOf(x.CountryCode) > -1);

		this.selectedCountry = this.searchCountry(µ.LicenceHolder.CountryCode);
		if (this.placeholder) {
			this.localPlaceholder = this.translateService.get(this.placeholder) + (this._elem.nativeElement.required ? ' *' : '');
		} else if (this.staticplaceholder != null) {
			this.localPlaceholder = this.staticplaceholder;
		}

		this.forceStaticPlaceholderForGb();
	}

	ngAfterViewInit() {
		(this.input.nativeElement as HTMLInputElement).addEventListener('input', (el) => {
			this.input.nativeElement.setSelectionRange(this.selectionStart, this.selectionEnd);
		});
	}

	searchCountry(countryCode) {
		let countrySearch = this.countries.filter((item) => {
			return item.CountryCode === countryCode;
		});

		if (countrySearch.length > 0) return countrySearch[0];
		else {
			countrySearch = this.countries.filter((item) => {
				return item.CountryCode === µ.LicenceHolder.CountryCode;
			});

			if (countrySearch.length > 0) return countrySearch[0];
			else return this.countries[0];
		}
	}

	toggleCountryList() {
		if (this.showList) this.hideCountryList();
		else this.showCountryList();
	}

	showCountryList() {
		if (this.readonly) return;

		this.showList = true;

		let doc = document.getElementsByTagName('html')[0];
		window.setTimeout(() => {
			doc.addEventListener('keyup', this.countrySelectKeyEvent, false);
			doc.addEventListener('keydown', this.countrySelectKeyEvent, false);
			doc.addEventListener('click', this.closeCountrySelectEventFunction, false);
		}, 10);
	}

	hideCountryList() {
		this.showList = false;

		let doc = document.getElementsByTagName('html')[0];
		doc.removeEventListener('keyup', this.countrySelectKeyEvent, false);
		doc.removeEventListener('keydown', this.countrySelectKeyEvent, false);
		doc.removeEventListener('click', this.closeCountrySelectEventFunction, false);
	}

	closeCountrySelectEventFunction = (event) => {
		if (
			event.target &&
			this._elem.nativeElement.querySelector('.select') !== event.target &&
			!this._elem.nativeElement.querySelector('.select').contains(event.target)
		) {
			this.hideCountryList();
		}
	};

	countrySelectKeyEvent = (event: KeyboardEvent) => {
		event.stopPropagation();
		event.preventDefault();

		if (event.type === 'keydown') return;

		switch (event.key) {
			case 'Enter':
				if (this.targetedCountry !== null) this.countryChange(this.targetedCountry);
				break;
			case 'ArrowDown':
				this.arrowMove(1);
				break;
			case 'ArrowUp':
				this.arrowMove(-1);
				break;
			case 'Escape':
				this.hideCountryList();
				break;
		}
	};

	arrowMove(direction: number) {
		let pos = -1;
		if (this.targetedCountry !== null) pos = this.countries.map((o) => o.CountryCode).indexOf(this.targetedCountry.CountryCode);

		let newPos = pos + direction;

		if (newPos >= 0 && newPos < this.countries.length) this.targetedCountry = this.countries[newPos];

		if (!this.showList) this.showCountryList();

		let targetElement = this.ulWrap.nativeElement.querySelector('.targeted');
		if (targetElement !== null) this.ulWrap.nativeElement.scrollTop = targetElement.offsetTop - targetElement.clientHeight;
	}

	// biome-ignore lint/suspicious/noExplicitAny: suppressed due to migration - should be fixed
	countryChange(country: any) {
		this.selectedCountry = country;
		this.model.countryCode = country.CountryCode;
		this.onCountryChange.emit(country.CountryCode);
		this.hideCountryList();
		this.validateAndEmitValue();
		this.forceStaticPlaceholderForGb();
	}

	selectCountryByCountryCode(countryCode: string) {
		let result = this.countries.filter((x) => x.CountryCode === countryCode);
		if (result.length > 0) {
			this.countryChange(result[0]);
		}
	}

	validateAndEmitValue(emit: boolean = true) {
		if (this.model.nin === '') this.model.nin = null;

		this.selectionStart = this.input ? this.input.nativeElement.selectionStart : 0;
		this.selectionEnd = this.input ? this.input.nativeElement.selectionStart : 0;

		if (this.model.nin !== null) {
			if (this.selectedCountry.CountryCode === 'GB') this.model.nin = this.model.nin.replace(/\s/g, '');
			else this.model.nin = this.model.nin.replace(/-/g, '');
			let numArray = this.model.nin.split('');
			let placeholderArray = this.selectedCountry.placeholder.split('');
			let placeholderArrayWithoutDashOrWhitespace: string[];

			if (this.selectedCountry.CountryCode === 'GB')
				placeholderArrayWithoutDashOrWhitespace = this.selectedCountry.placeholder.replace(/\s/g, '');
			else placeholderArrayWithoutDashOrWhitespace = this.selectedCountry.placeholder.replace('-', '').split('');

			// Country specific exceptions
			if (this.selectedCountry.CountryCode === 'SE') {
				if (
					numArray.length < placeholderArrayWithoutDashOrWhitespace.length &&
					NationalIdentityNumbers.Validator.validate(this.selectedCountry.CountryCode, this.model.nin, false)
				) {
					placeholderArray.splice(0, 2);
					placeholderArrayWithoutDashOrWhitespace.splice(0, 2);
				}
			}

			// If missing a - add it
			if (placeholderArray.indexOf('-') > -1 && numArray.length > placeholderArray.indexOf('-')) {
				// Yes, you are right. This is not how you should do this. 👍
				const index = placeholderArray.indexOf('-');
				let dontDoWeirdFiCheck = true;
				if (this.selectedCountry.CountryCode === 'FI' && numArray[index].toLowerCase() === 'a') {
					dontDoWeirdFiCheck = false;
				}

				if (dontDoWeirdFiCheck) {
					numArray.splice(index, 0, '-');

					if (this.model.nin.indexOf('-') === -1) {
						this.selectionStart++;
						this.selectionEnd++;
					}
				}
			}

			// If UK insert space instead
			if (placeholderArray.indexOf(' ') > -1 && numArray.length > placeholderArray.indexOf(' ')) {
				numArray.splice(placeholderArray.indexOf(' '), 0, ' ');
				this.selectionStart++;
				this.selectionEnd++;
			}
			if (placeholderArray.lastIndexOf(' ') > -1 && numArray.length > placeholderArray.lastIndexOf(' ')) {
				numArray.splice(placeholderArray.lastIndexOf(' '), 0, ' ');
				this.selectionStart++;
				this.selectionEnd++;
			}

			// Merge input with placeholder
			let meshArray = numArray.slice();
			if (numArray.length < placeholderArray.length) {
				for (var i = numArray.length; i < placeholderArray.length; i++) {
					meshArray[i] = placeholderArray[i];
				}
			}

			this.placeholderGenerated = meshArray.join('');
			this.model.nin = numArray.join('');
		} else {
			this.placeholderGenerated = this.selectedCountry.placeholder;
		}

		if (!emit) return;

		window.setTimeout(() => {
			// Timeout needed for emit to happen when writeValue needs formatting
			if (this.model.nin !== null) {
				this.propagateChange(this.model);
			} else {
				this.propagateChange({ nin: (this.model.nin || '').replace(/ /g, ''), countryCode: this.model.countryCode });
			}
			this.handleErrors();
		});

		if (typeof this.onChange !== 'undefined') {
			window.setTimeout(() => {
				this.onChange.emit(this.model);
			}, 10);
		}
	}

	handleErrors() {
		this.currentError = GlobalValidator.validateFormControl(
			this.translateService,
			this.controlDir.control as UntypedFormControl,
			this.errorMessages,
		);
	}

	forceStaticPlaceholderForGb() {
		if (this.selectedCountry.CountryCode === 'GB') {
			this.placeholderSwap = this.localPlaceholder;
			this.localPlaceholder = 'NHS number';
			this.alwaysShowPlaceholder = true;

			return;
		}

		const swap = this.localPlaceholder;
		this.placeholder = swap;
		this.localPlaceholder = null;
		this.alwaysShowPlaceholder = false;
	}
}
